export function buildResponse(response) {
    return {
        data: response.data ? response.data : {},
        statusCode: response.status,
        status: true,
        statusText: (response.statusText && response.statusText!="")?response.statusText:"success",
        message: response.data.message?response.data.message:"request was successful.",
    }
}
export function buildPostResponse(response) {
    return {
        data: response.data.data ? response.data.data : {},
        statusCode: response.status,
        status: true,
        statusText: (response.statusText && response.statusText!="")?response.statusText:"success",
        message: response.data.message?response.data.message:"request was successful.",
    }
}